export const COMPONENT_NAME = "block-pair";
